export const internalErrorConfig = {
  exparedOtp: 'OTP code has been expired'
} as const;
